import { DBDef_FHIRResource } from '@app/fhir-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_FHIRResource, ModuleFE_FHIRResourceSubtype, ModuleFE_FHIRResourceParam, ModuleFE_FHIRResourceParamValue } from '../../_entity.js';
import { Manager_FHIRResource } from '../../ui/_managers/Manager_FHIRResource/Manager_FHIRResource.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_FHIRResource,
    dbDef: DBDef_FHIRResource,
    tag: ['Fr', 'FHIR Resource'],
    modulesToAwait: [ModuleFE_FHIRResource, ModuleFE_FHIRResourceSubtype, ModuleFE_FHIRResourceParam, ModuleFE_FHIRResourceParamValue],
    ManagerComponent: Manager_FHIRResource,
    resultSubtitle: (resource) => resource?.urlPrefix,
});
export const WorkHubItem_FHIRResource = WorkHubItem;
export const UtilObject_FHIRResource = UtilObject;
export const SearchItem_FHIRResource = SearchItem;
//# sourceMappingURL=fhir-resource.js.map